import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 10' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'Glutes',
							value: 'Sumo Squats w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Scissors',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: 'Glutes',
							value: 'Glute Bridges w / (LB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Flutter Kicks',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: 'Glutes',
							value: 'Kneeling Hip Thrusts w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: 'Glutes',
							value: 'Hip Thrusts w / (DB) or (KB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Legs Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: 'Glutes',
							value: 'Sumo / Pulse Squats',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Toe Touches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
